import { togglePoliticiansDisplay } from 'components/chartSwitch/actions'
import { ActionType } from 'typesafe-actions'

export const displayPoliticiansReducer = (
  state: boolean = true,
  action: ActionType<typeof togglePoliticiansDisplay>
) => {
  if (action.type === togglePoliticiansDisplay.toString()) {
    return !state
  }

  return state
}
